import { render, staticRenderFns } from "./HeaderReport.vue?vue&type=template&id=0c0a544e&scoped=true"
import script from "./HeaderReport.vue?vue&type=script&lang=js"
export * from "./HeaderReport.vue?vue&type=script&lang=js"
import style0 from "./HeaderReport.vue?vue&type=style&index=0&id=0c0a544e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a544e",
  null
  
)

export default component.exports